import { makeAutoObservable } from "mobx";

export default class EvaluationStore {
    constructor() {
        makeAutoObservable(this);
    }

    // Evaluation instances
    evaluationInstances = [];
    currentInstance = null;

    // Set the list of evaluation instances
    setInstances = (instances) => {
        this.evaluationInstances = instances || [];
    };

    // Set the current instance being viewed or answered
    setCurrentInstance = (instance) => {
        this.currentInstance = instance;
    };

    // Clear the current instance
    clearCurrentInstance = () => {
        this.currentInstance = null;
    };

    // Store evaluation statistics
    evaluationStats = null;
    
    // Set evaluation statistics
    setEvaluationStats = (stats) => {
        this.evaluationStats = stats;
    };
    
    // Clear evaluation statistics
    clearEvaluationStats = () => {
        this.evaluationStats = null;
    };
} 